import { defineStore } from "pinia";
import { rootStore } from "..";
import { CommonHttp } from "../../models/interfaces/http/common.http.request";
import { LockedEntityType } from "../interfaces/types.analytics";

const API_URL = process.env.VUE_APP_API_URL;

export const useApiStore = defineStore("api", {
  actions: {

    // continue existing lock
    async prolongLock(entityId: number, entityType: LockedEntityType) {
      const rootstore = rootStore();

      const http = new CommonHttp(API_URL, rootstore.globalJWT);
      try {
        let response: any = undefined;
        await http
          .patch(`entity-locks?EntityId=${entityId}&EntityType=${entityType}`, {})
          .then((res) => {
            response = res;
          })
          .catch((err) => {
            console.log(err);
          });

        // @ts-ignore
        if (response && (response.status === 200 || response.status === 201)) {
          const { data } = response;
          return data;
        } else {
          console.log("Error response status:", response?.status);
        }
      } catch (e) {
        console.log(JSON.stringify(e));
      }

      return { response_ok: false };
    },

    // start entity lock
    async acquireLock(entityId: number, entityType: LockedEntityType) {
      const rootstore = rootStore();

      const http = new CommonHttp(API_URL, rootstore.globalJWT);
      try {
        let response: any = undefined;
        await http
          .post(`entity-locks?EntityId=${entityId}&EntityType=${entityType}`, {})
          .then((res) => {
            response = res;
          })
          .catch((err) => {
            console.log(err);
          });

        // @ts-ignore
        if (response && (response.status === 200 || response.status === 201)) {
          const { data } = response;
          return data;
        } else {
          console.log("Error response status:", response?.status);
        }
      } catch (e) {
        console.log(JSON.stringify(e));
      }

      return { response_ok: false };
    },

    // check if entity is locked
    async checkIfLocked(entityId: number, entityType: LockedEntityType) {
      const rootstore = rootStore();

      const http = new CommonHttp(API_URL, rootstore.globalJWT);
      try {
        let response: any = undefined;
        await http
          .get(`entity-locks?EntityId=${entityId}&EntityType=${entityType}`, {})
          .then((res) => {
            response = res;
          })
          .catch((err) => {
            console.log(err);
          });

        // @ts-ignore
        if (response && (response.status === 200 || response.status === 201)) {
          const { data } = response;
          return data;
        } else {
          console.log("Error response status:", response?.status);
        }
      } catch (e) {
        console.log(JSON.stringify(e));
      }

      return { response_ok: false };
    },

    // free entity from lock
    async finishLock(entityId: number, entityType: LockedEntityType) {
      const rootstore = rootStore();

      const http = new CommonHttp(API_URL, rootstore.globalJWT);
      try {
        let response: any = undefined;
        await http
          .delete(`entity-locks?EntityId=${entityId}&EntityType=${entityType}`)
          .then((res) => {
            response = res;
          })
          .catch((err) => {
            console.log(err);
          });

        // @ts-ignore
        if (response && (response.status === 200 || response.status === 201)) {
          const { data } = response;
          return data;
        } else {
          console.log("Error response status:", response?.status);
        }
      } catch (e) {
        console.log(JSON.stringify(e));
      }

      return { response_ok: false };
    },
  },
});
